
import { useState, useEffect } from 'react';
import { Chart } from 'primereact/chart';
import { Card } from './Layout/Card';
import { ScoreTrendViewModel } from '../../../ViewModel/ScoreTrendViewModel';
import 'chartjs-adapter-date-fns';
import { Icons } from './Icons/Icons';
import { JournalStrings } from './JournalStrings';


export default function ScoreTrendChart({ viewmodel }: { viewmodel: ScoreTrendViewModel }) {
    const [chartData, setChartData] = useState({});
    const [chartOptions, setChartOptions] = useState({});

    useEffect(() => {


        const data = viewmodel.ChartData;
        const options = {
            maintainAspectRatio: false,
            aspectRatio: 0.6,
            plugins: {
                legend: {
                    display: false
                }
            },
            scales: {
                x: {
                    type: 'time',
                    ticks: {
                        color: "#4E2B10",
                        font: {
                            size: 14,
                            family: "Helvetica Neue, Arial, sans-serif",
                            weight: "normal"
                        }
                    },
                    grid: {
                        color: "transparent"
                    }
                },
                y: {
                    ticks: {
                        color: "#4E2B10"
                    },
                    grid: {
                        color: "#D1C09CBA"
                    },
                    min: 0,
                    max: 10
                }
            }
        };

        setChartData(data);
        setChartOptions(options);
    }, []);

    return (
        <div className='gl-scoretrend-chart'>
            {
                viewmodel.ShowPlaceholder ?
                    <Card
                        noMargin
                        className="gl-placeholder-card gl-trends-placeholder mt-100 pt-1500"
                        disableClick
                    >
                        <div className="gl-home-section-title flex flex-row align-items-center justify-content-start">
                            <Icons.RotatedLeaf className="gl-home-placeholder gl-leaf " />
                            <p className="m-0">{JournalStrings.Home.Placeholders.Trends}</p>
                        </div>
                        <div className="flex flex-row gap-3">
                            <div>
                                <h4 className="gl-content-header-typograph mb-50 text-left color-copy-core">Scoring Chart</h4>
                                <Icons.ScoringChart className="gl-trends-placeholder-icon m-0" />
                            </div>
                            <div>
                                <h4 className="gl-content-header-typograph mb-50 text-left color-copy-core">Progress heat map</h4>
                                <Icons.ProgressHeatMap className="gl-trends-placeholder-icon m-0" />
                            </div>

                        </div>

                    </Card>
                    :
                    <Card noMargin disableClick>
                        <div className='flex flex-row justify-content-between align-items-center mb-25'>
                            <h3 className='gl-app-title-typography mt-0 mb-0'>Score</h3>
                            <div id="gl-legend-container">
                                <div className='flex flex-row justify-content-start align-items-center'>
                                    <div className='gl-circle mr-25 color-background-brand-green' />
                                    <p className='gl-legend-typography'>Weekly Trend</p>
                                </div>
                                <div className='flex flex-row justify-content-start align-items-center mt-50'>
                                    <div className='gl-circle mr-25 color-background-copy-core' />
                                    <p className='gl-legend-typography'>Monthly Trend</p>
                                </div>
                            </div>
                        </div>
                        <p className='gl-today-date-typography mt-0'>Visualize how your daily habits contribute to long-term growth</p>

                        <Chart className='gl-scoretrend-chart-chart' type="line" data={chartData} options={chartOptions} />
                    </Card>
            }
        </div>
    )
}
